import React, { useEffect, useState }  from 'react';
import BasicView from '../components/BasicView';
import ViewError from '../components/ViewError';
import auth from '../../../service/Auth';
import {statics_data_access} from '../../../service/apis';
import { Redirect } from "react-router-dom";
const config = window.config;

const StaticsDataAccess = () => {

    const [headers, setHeaders] = useState([]);
    const [data, setData] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const [errors, setErrors] = useState("");
    const [redirectExperimentInformation, setRedirectExperimentInformation] = useState("");
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);

    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setErrors("Logging session timeout. Please log again");
        }
        else {
            //Define Headers
            setHeaders([
                { label: "Experiment" , key: "sample__RD_Connect_ID_Experiment"},
                { label: "Individual accesses", key: "individualcount" },
                { label: "Search across all accesses", key: "allcount" },
                { label: "Total accesses", key: "totalcount" }
            ]);
            // Get data access stats
            statics_data_access(auth.getToken(),config.api_endpoint)
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                setData(data);
                setLoadData(false);
            })
        }
    },[])

    const getTableHeaders = () => {
        // Set view columns 
        let columns = []
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            columns.push(column);
        }
        setHeadersTable(columns);
    }
  
    const getDataTable = () => {
       // Build data for view table
       let rows = [];
       for (let rowData of data){
           let row = {};
           //1. Loop Headers
           for (let column of headersTable){
               if (column.accessor in rowData) {
                   row[column.accessor] = rowData[column.accessor];
               } else {
                   row[column.accessor] = "unknown";
               }
           }
           //2. Add row to data
           rows.push(row);
      }
      //Update columns and data
      setRowsTable(rows);
    }

    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[data])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])

    const closeModal = () => {
       setErrors("");
    }

    const onRowClick = (state, rowInfo, column, instance) => {
        // Handle row clicks
        return {
            onClick: e => {
               // If row is Experiment ID then Route to Experiment Information
                if(rowInfo){
                    setRedirectExperimentInformation(rowInfo.original.sample__RD_Connect_ID_Experiment);
                }
            }
        }
    };

    if (errors !== "") {
        // Show ViewError in case an error with the loggin occurs
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else if (redirectExperimentInformation !== "") {
        // Redirect to Experiment Info View If Cell Experiment ID Is Clicked 
        return <Redirect to={{pathname:'/detailedStaticsDataAccess/'+ redirectExperimentInformation}}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <BasicView title="Statistics on Experiment Access"
                           headers={headers}
                           columns={headersTable}
                           data={rowsTable}
                           defaultPageSize={100}
                           onRowClick={onRowClick}
                           loading={loadData}
                />                
            </div>
        );
    }
}

export default StaticsDataAccess;